import { InfoCircle } from "iconsax-react";
import { Link } from "react-router-dom";
import { Tooltip } from "react-tooltip";

export default function TotalNumberCard(props) {
  return (
    <>
      <Link
        to={props.href || "#"}
        className="col-span-1 px-3 py-4 rounded-[8px] shadow-sm hover:shadow-md cursor-pointer transition-all bg-white border relative"
      >
        <div className="flex gap-3 items-center">
          <div
            style={{ backgroundColor: props.color }}
            className="h-8 w-8 text-white rounded-full flex justify-center items-center"
          >
            {props.icon}
          </div>

          <div>
            <div className="uppercase font-medium text-gray-500 text-[12px]">
              {props.title}
            </div>
            <div className="text-2xl font-bold">{props.value}</div>
          </div>
        </div>
        {props.tooltip && (
          <div className="absolute top-3 right-3">
            <InfoCircle
              data-tooltip-id={"tooltip"}
              data-tooltip-content={props.tooltip}
              data-tooltip-place="top"
              size={14}
            />
          </div>
        )}
      </Link>
      <Tooltip id="tooltip" style={{ fontSize: "12px" }} />
    </>
  );
}
